// Angular
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { LanguageModel } from './language.model';

@Component({
  selector: 'kt-language-selector',
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
  // Public properties
  @HostBinding('class') classes = '';
  @Input() iconType: '' | 'brand';

  availableLanguages: LanguageModel[] = [
    {
      lang: LanguageType.Polish,
      name: 'Polski',
      flag: './assets/media/flags/211-poland.svg'
    },
    {
      lang: LanguageType.English,
      name: 'English',
      flag: './assets/media/flags/260-united-kingdom.svg'
    }
  ];

  supportedLanguages: string[] = [
    LanguageType.Polish, LanguageType.English
  ];

  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    this.setLanguage(this.translationService.getSavedLanguageOrBrowserDefault());
  }

  setLanguage(lang: string) {
    if (this.isLanguageSupported(lang)) {
      // Select proper language in dropdown
      this.availableLanguages.map((language: LanguageModel) => {
        language.isActive = language.lang === lang;
      });

      // Set selected language
      this.translationService.setLanguage(lang);
    }
  }

  setLanguageManually(lang: string) {
    this.setLanguage(lang);
    window.location.reload();
  }

  private isLanguageSupported(language: string): boolean {
    return this.supportedLanguages.includes(language);
  }
}
